import Model, { attr, belongsTo, hasMany } from '@ember-data/model'

export default class TimingChannelModel extends Model 
{
	@attr name;
	@attr function;
	
	@belongsTo('timing-device', {inverse:null, async: true}) TimingDeviceId;
}